module.exports = __webpack_public_path__ + "static/img/app-store-badge-en.61368fb.png";